function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.58143 15.9996H0.264286V5.3175H3.58143V15.9996ZM1.92107 3.86036C0.860357 3.86036 0 2.98179 0 1.92107C7.59214e-09 1.41157 0.202398 0.922939 0.562669 0.562669C0.92294 0.202398 1.41157 0 1.92107 0C2.43057 0 2.9192 0.202398 3.27947 0.562669C3.63974 0.922939 3.84214 1.41157 3.84214 1.92107C3.84214 2.98179 2.98143 3.86036 1.92107 3.86036ZM15.9964 15.9996H12.6864V10.7996C12.6864 9.56035 12.6614 7.97107 10.9618 7.97107C9.23714 7.97107 8.97286 9.3175 8.97286 10.7104V15.9996H5.65929V5.3175H8.84071V6.77464H8.88714C9.33 5.93536 10.4118 5.04964 12.0257 5.04964C15.3829 5.04964 16 7.26036 16 10.1318V15.9996H15.9964Z",
  fill: "#585858"
});

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b4e54e11.svg";
export { ForwardRef as ReactComponent };